import React, { type LegacyRef } from 'react'

import Button from '@/shared/components/button/Button'
import Input from '@/shared/components/input/Input'
import { Caption, Text } from '@/shared/components/typography'

type PurchaseCarNumProps = {
  value: string
  placeholder: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  disabled: boolean
  contentHeight: number
  footerRef: LegacyRef<HTMLDivElement>
  handleCarNumNextBtn: () => void
}

const PurchaseCarNum = ({
  value,
  placeholder,
  onChange,
  disabled,
  footerRef,
  contentHeight,
  handleCarNumNextBtn
}: PurchaseCarNumProps) => {
  return (
    <>
      <div className={`flex flex-1 justify-center`} style={{ height: contentHeight, overflow: 'scroll' }}>
        <div className="flex w-full flex-col items-center bg-010 pt-4">
          <Text level="text1" color="text090" weight="bold">
            차량번호를 입력해 주세요.
          </Text>
          <div className="mb-[9px] mt-10 flex w-full flex-col gap-2 px-4">
            <Text level="text3" color="text090">
              차량번호
            </Text>
            <Input
              className={`border-b-[1px] border-060 pb-2 ${
                value.length ? 'font-medium' : 'font-regular'
              } leading-26 focus:border-main-050`}
              value={value}
              placeholder={placeholder}
              onChange={onChange}
              length={9}
              autoFocus={true}
            />
            {value.length >= 7 && disabled && (
              <Caption level="caption2" color="caution070">
                올바른 차량번호 형식으로 입력해 주세요.
              </Caption>
            )}
            <div className="mt-6 rounded-md bg-020 px-3 py-3">
              <ol className="list-disc">
                <li className="list-style-desc-car">
                  <Caption level="caption2" color="text090">
                    <span className="text-caution-070">차량번호를 정확히 입력</span>해 주세요.
                  </Caption>
                </li>
                <li className="list-style-desc-car">
                  <Caption level="caption2" color="text090">
                    <span className="text-caution-070">임시번호판 차량은 이용이 불가</span>합니다.
                  </Caption>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="sticky bottom-0" ref={footerRef}>
        <div className="w-full gap-3 bg-010 px-4 py-3">
          <Button
            text="다음"
            color="text010"
            background="bg030"
            className="body-1 h-[56px]"
            pyValue="py-0"
            disabled={disabled}
            onClick={handleCarNumNextBtn}
          />
        </div>
      </div>
    </>
  )
}

export default PurchaseCarNum
